var _path, _path2, _circle, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterVenue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.0092C0 1.16571 0.68378 0.481934 1.52727 0.481934H10.1181V16.5182H1.52727C0.683782 16.5182 0 15.8344 0 14.991V2.0092Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.0092C22 1.16571 21.3162 0.481934 20.4727 0.481934H12V16.4819H20.4727C21.3162 16.4819 22 15.7982 22 14.9547V2.0092Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.118,
    cy: 8.69102,
    r: 2.86362,
    fill: "#FF4E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05462 8.69102C3.05462 10.2726 1.58154 11.5546 0 11.5546C-9.12142e-05 10.791 0 10.0816 0 8.50011C0 6.91857 0 7.16375 0 5.82739C1.58154 5.82739 3.05462 7.10948 3.05462 8.69102Z",
    fill: "#FF4E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9454 8.69102C18.9454 10.2726 20.4185 11.5546 22 11.5546C22.0001 10.791 22 10.0816 22 8.50011C22 6.91857 22 7.16375 22 5.82739C20.4185 5.82739 18.9454 7.10948 18.9454 8.69102Z",
    fill: "#FF4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterVenue);
export default __webpack_public_path__ + "static/media/register-venue.b1918e4dcb20004338968b2afda071d3.svg";
export { ForwardRef as ReactComponent };